import Typography from "@material-ui/core/Typography";
import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { Avatar, makeStyles, Button, Grid,  } from "@material-ui/core";
import { Checkbox, Popover } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import Left from './Left'
const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: "flex",
      width: "100%",
      flex: 1,
      height: '1px'
    },
    page: {
      flex: "1",
      height: "100%",
      padding: "0",
      background: "#F0F2F5",
    },
    boyingTxt: {
      width: 100,
      height: 50,
      marginRight: "30px",
    },
    contentBox: {
      width: '100%',
      maxHeight: '70vh',
      marginTop: '24px',
      padding: '0 40px',
      overflow: 'auto',
      whiteSpace: 'pre'
    },
    icon: {
      position: 'absolute',
      right: '-10px',
      top: '-10px',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #1890ff',
      background: '#fff',
      borderRadius: '50%',
      cursor: 'pointer',
    },
    title: {
      width: "90%",
      minHeight: "50px",
      margin: '0 auto',
      padding: "13px 20px",
      textAlign: 'center',
      fontSize: "18px !important",
      lineHeight: '24px',
      color: "#333",
      boxSizing: "border-box",
      fontWeight: "bold !important",
    },
    subTitle: {
      fontSize: "14px !important",
      lineHeight: '20px',
      color: "#666",
      textAlign: 'center',
    },
    time: {
      marginLeft: '40px'
    },
    content: {
      width: '100%',
      fontSize: '14px !important',
      color: "#333",
      lineHeight: '19px'
    },
    footer: {
      width: '100%',
      marginTop: '20px',
      padding: '0 40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    btn: {
      marginLeft: '10px',
      fontSize: '14px !important',
      color: '#1890ff',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    kefu: {
      position: 'fixed',
      right: '23px',
      bottom: '30px',
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      background: '#0F55A4',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: '100',
      cursor: 'pointer',
      '& img': {
        width: '36px',
        height: '36px'
      }
    },
    email: {
      position: 'fixed',
      right: '23px',
      bottom: '100px',
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      background: '#0F55A4',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: '100',
      cursor: 'pointer',
      '& img': {
        width: '36px',
        height: '36px'
      }
    }
    
  };
});

export default function Layout({ children }) {

 
  const classes = useStyles();
  const username = useSelector((state) => state.auth.username);
  const [isInit, setIsInit] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [checked, setChecked] = useState(false)
  const [noticeObj, setNoticeObj] = useState({ })
  const [cancelObj, setCancelObj] = useState({ })

 

  return (
    <div className={classes.root}>
      <Left/>
      <div className={classes.page}>
        {children}
      </div>
    </div>
  );
}
